module.exports = __webpack_public_path__ + "img/fm-f-Path 58 Copy@3x.83918224.png";